import { groupBy, orderBy } from 'lodash';
import { createSelector } from 'reselect';
import {
  getActiveRetirementAccounts,
  getActiveNonRetirementAccounts,
  getBrokerageAccountsFromSweepMap
} from 'state/account/AccountSelectors';
import { removeWhitespace } from 'services/Formats';
import { extractAndFormatOwners } from 'services/Accounts';

export const getAccountRegistrationTableData = createSelector(
  getActiveRetirementAccounts,
  getActiveNonRetirementAccounts,
  getBrokerageAccountsFromSweepMap,
  (retirementAccounts, nonRetirementAccounts, linkedBrokerageAccountsMap) => {
    const transformedRetirementAccounts = retirementAccounts.map((account) => {
      const { accountRegistration, sweepAccount, accountId } = account;
      const formattedOwners = extractAndFormatOwners(account);
      const accountRegistrationKey =
        accountRegistration &&
        accountRegistration
          .map((registrationLine) => removeWhitespace(registrationLine))
          .join(',');
      const sweepAccountFromMap = linkedBrokerageAccountsMap[accountId];
      const sweepAccountWChecksum =
        sweepAccount &&
        `${sweepAccountFromMap.accountNumber}-${sweepAccountFromMap.accountChecksum}`;
      return {
        ...account,
        accountRegistrationKey,
        owners: formattedOwners,
        sweepAccountWChecksum
      };
    });

    const transformedNonRetirementAccounts = nonRetirementAccounts.map(
      (account) => {
        const { accountRegistration, sweepAccount, accountId } = account;
        const formattedOwners = extractAndFormatOwners(account);
        const accountRegistrationKey =
          accountRegistration &&
          accountRegistration
            .map((registrationLine) => removeWhitespace(registrationLine))
            .join(',');
        const sweepAccountFromMap = linkedBrokerageAccountsMap[accountId];
        const sweepAccountWChecksum =
          sweepAccount &&
          `${sweepAccountFromMap.accountNumber}-${sweepAccountFromMap.accountChecksum}`;
        return {
          ...account,
          accountRegistrationKey,
          owners: formattedOwners,
          sweepAccountWChecksum
        };
      }
    );

    const sortedRetirement = orderBy(transformedRetirementAccounts, [
      'accountType',
      'owners'
    ]);
    const sortedNonRetirement = orderBy(transformedNonRetirementAccounts, [
      'accountType',
      'owners'
    ]);

    return {
      retirementRegistrations: groupBy(
        sortedRetirement,
        (a) => a.accountRegistrationKey
      ),
      nonRetirementRegistrations: groupBy(
        sortedNonRetirement,
        (a) => a.accountRegistrationKey
      )
    };
  }
);
